import { badgesDispatches } from 'pages/integrations/containers/BadgesContainer/constants';
import { badgesService } from 'services/integrations';
import { messageNotification } from 'helpers';

export const fetchBadgeConfigs = () => {
  return (dispatch) => {
    dispatch(badgesDispatches.fetchBadgeConfigsRequest());
    badgesService
      .fetchBadgeConfigs()
      .then((data) => dispatch(badgesDispatches.fetchBadgeConfigsSuccess(data)))
      .catch((error) => dispatch(badgesDispatches.fetchBadgeConfigsFailure(error)));
  };
};

export const fetchBadgeGroups = (provider = 'accredible') => {
  return (dispatch) => {
    dispatch(badgesDispatches.fetchBadgeGroupsRequest());
    badgesService
      .fetchBadgeGroups(provider)
      .then((data) => dispatch(badgesDispatches.fetchBadgeGroupsSuccess(data)))
      .catch((error) => dispatch(badgesDispatches.fetchBadgeGroupsFailure(error)));
  };
};

export const createBadgeConfig = (data, provider = 'accredible', onComplete) => {
  return (dispatch) => {
    badgesService
      .createBadgeConfig(data, provider)
      .then(() => {
        messageNotification('success', 'Success', 'API configuration created.');
        dispatch(fetchBadgeConfigs());
      })
      .catch((error) => {
        const msg = error.response?.data?.error || 'Failed to create configuration.';
        messageNotification('danger', 'Error', msg);
      })
      .finally(() => {
        if (onComplete) onComplete();
      });
  };
};

export const updateBadgeConfig = (id, data, provider = 'accredible', onComplete) => {
  return (dispatch) => {
    badgesService
      .updateBadgeConfig(id, data, provider)
      .then(() => {
        messageNotification('success', 'Success', 'API configuration updated.');
        dispatch(fetchBadgeConfigs());
      })
      .catch((error) => {
        const msg = error.response?.data?.error || 'Failed to update configuration.';
        messageNotification('danger', 'Error', msg);
      })
      .finally(() => {
        if (onComplete) onComplete();
      });
  };
};

export const deleteBadgeConfig = (id, provider = 'accredible') => {
  return (dispatch) => {
    badgesService
      .deleteBadgeConfig(id, provider)
      .then(() => {
        messageNotification('success', 'Success', 'Badge provider removed.');
        dispatch(badgesDispatches.clearBadgeData());
      })
      .catch((error) => {
        const msg = error.response?.data?.error || 'Failed to delete configuration.';
        messageNotification('danger', 'Error', msg);
      });
  };
};

export const syncBadgeGroups = (configId, provider = 'accredible', onComplete) => {
  return (dispatch) => {
    badgesService
      .syncBadgeGroups(configId, provider)
      .then(() => {
        messageNotification('success', 'Success', 'Groups synced successfully.');
        dispatch(fetchBadgeGroups(provider));
      })
      .catch((error) => {
        const msg = error.response?.data?.error || 'Failed to sync groups.';
        messageNotification('danger', 'Error', msg);
      })
      .finally(() => {
        if (onComplete) onComplete();
      });
  };
};

export const updateBadgeGroup = (groupId, provider, data) => {
  return () => {
    return badgesService.updateBadgeGroup(groupId, provider, data).catch((error) => {
      const msg = error.response?.data?.detail || 'Failed to update group.';
      messageNotification('danger', 'Error', msg);
      throw error;
    });
  };
};

export const createBadgeRequirement = (data) => {
  return () => {
    return badgesService.createBadgeRequirement(data).catch((error) => {
      const msg = error.response?.data?.detail || 'Failed to create requirement.';
      messageNotification('danger', 'Error', msg);
      throw error;
    });
  };
};

export const updateBadgeRequirement = (id, data) => {
  return () => {
    return badgesService.updateBadgeRequirement(id, data).catch((error) => {
      const msg = error.response?.data?.detail || 'Failed to update requirement.';
      messageNotification('danger', 'Error', msg);
      throw error;
    });
  };
};

export const deleteBadgeRequirement = (id, onSuccess) => {
  return () => {
    badgesService
      .deleteBadgeRequirement(id)
      .then(() => {
        messageNotification('success', 'Success', 'Requirement deleted.');
        if (onSuccess) onSuccess();
      })
      .catch((error) => {
        const msg = error.response?.data?.detail || 'Failed to delete requirement.';
        messageNotification('danger', 'Error', msg);
      });
  };
};

export const badgesActions = {
  fetchBadgeConfigs,
  fetchBadgeGroups,
  createBadgeConfig,
  updateBadgeConfig,
  deleteBadgeConfig,
  syncBadgeGroups,
  updateBadgeGroup,
  createBadgeRequirement,
  updateBadgeRequirement,
  deleteBadgeRequirement
};
